<template>
  <div class="form-row">
    <label :for="`support-${$attrs.name}`" class="form-title">
      {{ $attrs.title }}
      <small v-if="$attrs.required" class="required">필수</small>
      <slot />
    </label>
    <validation-provider
      v-slot="{ errors }"
      :name="$attrs.title"
      :rules="$attrs.rules"
    >
      <div
        v-if="conditionsToShow"
        :class="[formClass, {
          'is-invalid': errors.length > 0 || errorMessage.length > 0
        }]"
      >
        <span class="form-control-wrap">
          <span v-if="$attrs.type === 'file'" class="form-control" :class="{'form-uploaded': isUpload}">
            <icon-uploaded v-if="isUpload" class="icon" />
            <icon-plus v-else class="icon" />
            <input
              :id="`support-${$attrs.name}`"
              v-bind="$attrs"
              v-on="inputListeners"
              @input="$emit('input', $event.target.files)"
            >
            <span v-if="loading" class="form-control-message">업로드중입니다.</span>
            <template v-else>
              <template v-if="isUpload">
                <span class="form-control-message">
                  <!--              {{ $t('question.attachFileUploaded') }}-->
                  {{ value }}
                </span>
                <icon-delete class="form-control-file-remove" @click.stop="onRemoveAttachFile" />
              </template>
              <i v-else class="form-control-message">{{ $attrs.placeholder }}</i>
            </template>
          </span>

          <div v-else-if="$attrs.type === 'textarea'" class="form-textarea">
            <textarea
              :id="`support-${$attrs.name}`"
              v-bind="$attrs"
              v-on="inputListeners"
              @input="$emit('input', $event.target.value)"
            />
          </div>

          <input
            v-else
            :id="`support-${$attrs.name}`"
            class="form-control"
            v-bind="$attrs"
            v-on="inputListeners"
            @input="$emit('input', $event.target.value)"
          >
        </span>
      </div>
      <p v-for="(item, key) in errors" :key="key" class="is-invalid-message">{{ item }}</p>
      <p v-if="errorMessage" class="is-invalid-message">{{ errorMessage }}</p>
    </validation-provider>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
export default {
  components: {
    ValidationProvider,
    iconPlus: () => import('@/static/svg/plus.svg'),
    iconUploaded: () => import('@/static/svg/attach-uploaded.svg'),
    iconDelete: () => import('@/static/svg/delete.svg')
  },
  inheritAttrs: false,
  props: {
    isUpload: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    }
    // title: {
    //   type: String,
    //   default: ''
    // },
    // name: {
    //   type: String,
    //   default: ''
    // },
    // placeholder: {
    //   type: String,
    //   default: ''
    // },
    // required: {
    //   type: Boolean,
    //   default: false
    // },
    // type: {
    //   type: String,
    //   default: ''
    // },
    // value: {
    //   type: [String, FileList],
    //   default: ''
    // }
  },
  data () {
    return {
      typeList: ['text', 'email', 'textarea', 'file'],
      value: null
    }
  },
  computed: {
    // fileName () {
    //   if (this.contents[0]) {
    //     return this.contents[0].name
    //   }
    //   return '파일을 첨부해주세요.'
    // },
    conditionsToShow () {
      const show = this.typeList.find(v => {
        return v === this.$attrs.type
      })
      return !!show
    },
    formClass () {
      return {
        'form-attach': this.$attrs.type === 'file',
        'form-control-container': this.$attrs.type === 'text' || this.$attrs.type === 'file',
        'form-textarea': this.$attrs.type === 'textarea'
      }
    },
    inputListeners () {
      const vm = this
      return Object.assign({},
          this.$listeners,
          {
            input: function (event) {
              vm.$emit('input', event.target.value)

              if (event.target.files && event.target.files.length > 0) {
                vm.value = event.target.files[0].name
              } else {
                vm.value = event.target.value
              }
            }
          })
    }

    // contents: {
    //   get (v) {
    //     return this.value
    //   },
    //   set (newValue) {
    //     this.$emit('input', newValue)
    //     return newValue
    //   }
    // }
  },
  mounted () {

  },
  methods: {
    onRemoveAttachFile () {
      this.$attrs.value = ''
      this.$emit('change:delete')
    }
    // onInput (value) {
    //   this.contents = value
    // },
    // onfocus () {
    //   this.$refs[this.$attrs.id].focus()
    // }
  }
}
</script>
